// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.VehicleTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  min-height: calc(100vh - var(--header-height));
}
.Table.VehicleTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
  border-width: 1px 0;
}
.Table.VehicleTable table .TableRow {
  display: grid;
  grid-template-columns: 3rem repeat(7, minmax(0, 1fr));
  width: 100%;
  min-width: 0;
}
.Table.VehicleTable table .TableRow + .TableRow {
  border-top: var(--border);
}
.Table.VehicleTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
}
.Table.VehicleTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Table.VehicleTable table .TableRow .TableCell {
  min-width: 0;
}
.Table.VehicleTable table .TableRow .TableCell + .TableCell {
  border-left: var(--border);
}
.Table.VehicleTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  text-align: center;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
.Table.VehicleTable table .TableRow .TableCell.SELECT .TableCell-Content .SwitchInput {
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/features/Vehicles/components/VehicleTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,8CAAA;AADF;AAGE;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;AADN;AAGM;EACE,yBAAA;AADR;AAIM;EACE,4BAAA;AAFR;AAIQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAFV;AAMM;EACE,YAAA;AAJR;AAKQ;EACE,0BAAA;AAHV;AAMQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAJV;AASY;EACE,uBAAA;AAPd","sourcesContent":["@import '../../../../globals.scss';\n\n.Table.VehicleTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  min-height: calc(100vh - var(--header-height));\n\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    border-width: 1px 0;\n\n    .TableRow {\n      display: grid;\n      grid-template-columns: 3rem repeat(7, minmax(0, 1fr));\n      width: 100%;\n      min-width: 0;\n\n      + .TableRow {\n        border-top: var(--border);\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n\n        .TableCell-Content {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .TableCell {\n        min-width: 0;\n        + .TableCell {\n          border-left: var(--border);\n        }\n\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          text-align: center;\n          white-space: normal;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n        }\n\n        &.SELECT {\n          .TableCell-Content {\n            .SwitchInput {\n              justify-content: center;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
